import './vendor';

import Inputmask from "../.../../../node_modules/inputmask/dist/jquery.inputmask.min";
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
import Swiper from 'swiper';
import { Pagination, Navigation, Mousewheel } from 'swiper/modules';
Swiper.use([Pagination, Navigation, Mousewheel ]);
import iziToast from 'izitoast'
import Mmenu from 'mmenu-js'

document.addEventListener(
	"DOMContentLoaded", () => {
	    new Mmenu( "#menu", {
	       "offCanvas": {
		  "position": "bottom"
	       },
	       navbar: {
			title: "Меню"
		},
	       "theme": "dark"
	    });
	}
);


function setupModalButtonHandlers(buttonSelector, modalSelector, titleSelector, themeSelector) {
	let buttons = document.querySelectorAll(buttonSelector);
	if (buttons.length > 0) {
	  buttons.forEach(button => {
	    button.addEventListener('click', function() {
	      replaceTitleModal(this, modalSelector, titleSelector, themeSelector);
	    });
	  });
	}
      
	function replaceTitleModal(button, modalSelector, titleSelector, themeSelector) {
	  let modal = document.querySelector(modalSelector);
	  let title = modal.querySelector(titleSelector);
	  let theme = modal.querySelector(themeSelector);
	  title.innerHTML = button.dataset.title;
	  theme.value = button.dataset.title;
	}
      }
      
// Вызов функции с указанными аргументами
setupModalButtonHandlers('.btn--modal', '#callback', '.form__title', '.form__theme');





const swiper = new Swiper('.slider', {
	speed: 1600,
  	loop: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	
})

const partners = new Swiper('.partners', {
	speed: 1600,
  	loop: true,
	slidesPerView: 5,
	spaceBetween: 20,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		1920: {
		    slidesPerView: 5,
		},
		991: {
		    slidesPerView: 5,
		},
		576: {
		    slidesPerView: 4,
		    spaceBetween: 12,
		},
		320: {
		    slidesPerView: 2,
		    spaceBetween: 10,
		}
	    }
	
})





 $(".inputmask").inputmask({"mask": "+7 (999) 999-9999"});

/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".form").submit(function() {
	var th = $(this);
	$.ajax({
	    type: "POST",
	    url: "/assets/mail.php", 
	    data: th.serialize()
	}).done(function() {
		iziToast.success({
			title: 'Отправлено',
			position: 'topCenter',
			message: 'Ваша заявка принята',
			class: 'iziModalCustom',
			progressBarColor: '#F8DF04',
			close: false,
			titleColor: '#fff',
			messageColor: '#94ADEB',
			backgroundColor: '#1D429B',
			timeout: 2000,
			pauseOnHover: false,

		});
	    setTimeout(function() {
		$.magnificPopup.close();
		th.trigger("reset");
	    }, 2000);
	});
	return false;
});

/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		tCounter: '%curr% из %total%' ,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});


function setupTabs(tabItemSelector, tabContentItemSelector, tabContentWrapperSelector, mobileTabClass) {
	const tabs = document.querySelectorAll(tabItemSelector);
	const tabContentItems = document.querySelectorAll(tabContentItemSelector);
	let isMobile = window.innerWidth < 576;
    
	// Function to show a tab
	function showTab(index) {
	    tabs.forEach((tab, i) => {
		if (i === index) {
		    tab.classList.add('is-active');
		    tabContentItems[i].style.display = 'block';
		} else {
		    tab.classList.remove('is-active');
		    tabContentItems[i].style.display = 'none';
		}
	    });
	}
    
	// Initial setup
	showTab(0);
	updateMobileTabs();
    
	// Bind click event to tabs
	tabs.forEach((tab, index) => {
	    tab.addEventListener('click', () => {
		if (!tab.classList.contains('is-active')) {
		    showTab(index);
		}
	    });
	});
    
	// Handle resize
	window.addEventListener('resize', function () {
	    const currentIsMobile = window.innerWidth < 576;
	    if (currentIsMobile !== isMobile) {
		isMobile = currentIsMobile;
		updateMobileTabs();
	    }
	});
    
	// Update tabs for mobile view
	function updateMobileTabs() {
	    tabContentItems.forEach((item, index) => {
		let mobileTab = item.querySelector('.' + mobileTabClass);
		if (isMobile) {
		    if (!mobileTab) {
			mobileTab = document.createElement('div');
			mobileTab.className = mobileTabClass;
			mobileTab.textContent = tabs[index].textContent;
			item.prepend(mobileTab);
    
			mobileTab.addEventListener('click', function () {
			    mobileTab.classList.toggle('is-active');
			    const contentWrapper = item.querySelector(tabContentWrapperSelector);
			    contentWrapper.classList.toggle('is-hidden');
			});
		    }
		    item.querySelector(tabContentWrapperSelector).classList.add('is-hidden');
		} else {
		    if (mobileTab) {
			mobileTab.remove();
		    }
		    item.querySelector(tabContentWrapperSelector).classList.remove('is-hidden');
		}
	    });
	}
    }
    
// Вызов функции с указанными аргументами для настройки вкладок
setupTabs('.tabs__item', '.tabs__contentitem', '.tabs__contentwrapper', 'tabs__mobiletab');